import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FundShareTakeAction.css'
import config from '../../config'
import analytics from '../../helpers/analytics'
import {
  Link,
  // SocialButtons,
  // GetStartedInput,
  // RecentBlogPosts,
  AboutBanner,
  LinkIcon,
  Returns
} from '../'
// import {Row, Col} from 'react-flexbox-grid'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'

@CSSModules(Styles)
export default class FundShareTakeAction extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    shareClass: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props);
  }

  renderTakeAction = (shareClass) =>{
    function renderAction(info, button, link, log) {
      return (
        <div styleName='take-action-action'>
          <div styleName='take-action-info'>{info}</div>
          <div styleName='take-action-button-wrap'>
            <Link
              to={link}
              log={log}
              title={button}>
              <div styleName='take-action-button'>
                {button} <i className='fa fa-angle-double-right'/>
              </div>
            </Link>
          </div>
        </div>
      )
    }
    return (
      <div styleName='take-action-wrap'>
        <div styleName='take-action-anchor' id='take-action'/>
        <div styleName='take-action'>
          <div styleName='take-action-inner'>

            {renderAction( 'Ask your employer about gender-lens investing in your retirement plan',
            'Use our toolkit', config.routes.toolkit, analytics.eventToToolkit() )}

            {renderAction( 'Find socially responsible funds that invest in gender equality',
            'Find top-scoring funds', config.routes.clean )}

            {renderAction( 'Learn more about As You Sow\'s Invest Your Values program',
            'Invest Your Values', config.links.aysinvest )}

            {renderAction( 'Visit Fossil Free Funds to measure the climate risk of this portfolio',
            'See climate risk',
            config.links.fffFund+'/'+shareClass.fund_id+'/'+shareClass.investment_vehicle_id,
            analytics.eventToFFF(shareClass.fund_id,shareClass.investment_vehicle_id) )}

          </div>
        </div>
      </div>
    )
  }

  render() {
    const shareClass = this.props.shareClass
    const fund = this.props.fund
    const url = this.props.url
    // <Link to={config.links.speakout} bigbutton={true}>Take Action</Link>

    return (
      <div>
        { /* <Returns
          fund={fund}
          shareClass={shareClass}
          url={url}
        /> */ }
        <div styleName='holdings-count'>
          <div styleName='holdings-count-wrap'>
            <div styleName='holdings-count-social'>
              <div styleName='holdings-count-headline'>
                What's next?
              </div>
              <div styleName='holdings-count-intro'>
                Learn how to make a change and move your money
              </div>
              <div styleName='holdings-count-intro'>
                Get started with our action toolkit
              </div>
              <div styleName='holdings-count-button'>
                <Link
                  to={config.routes.toolkit}
                  primarybutton={true}
                  title='Fossil free action toolkit'>
                  Action toolkit<LinkIcon />
                </Link>
              </div>
            </div>

          </div>

          {/* <SocialButtons
            message={config.app.title+' - '+shareClass.fund_legal_name}
            link={url}
          /> */ }

          {/* <GetStartedInput /> */ }

        </div>

        { /* <RecentBlogPosts /> */ }

        { this.renderTakeAction(shareClass) }

        <div styleName='banner'>
          <div styleName='banner-inner'>
            <AboutBanner />
          </div>
        </div>

      </div>
    )
  }
}